var map = {
	"./de.json": [
		1703,
		41
	],
	"./en-AU.json": [
		1704,
		42
	],
	"./en-GB.json": [
		1705,
		43
	],
	"./en-HK.json": [
		1706,
		44
	],
	"./en-SG.json": [
		1707,
		45
	],
	"./en-us.json": [
		1708,
		46
	],
	"./fr.json": [
		1709,
		47
	],
	"./global.json": [
		1710,
		48
	],
	"./it.json": [
		1711,
		49
	],
	"./zh-Hant.json": [
		1712,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1700;
module.exports = webpackAsyncContext;